import { env } from ".env";
import blueLockIcon from "assets/icons/blueLockIcon.svg";
import bluePhoneIcon from "assets/icons/bluePhoneIcon.svg";
import avashologo from "assets/images/logo.svg";
import { CustomButton } from "components/component-styles/buttons/index.styled";
import { FormContainer } from "components/component-styles/alignment";
import FormikControl from "components/form/formikControl";
import Shape from "components/layout/authShapes";
import { UserInfoContext } from "contexts/userInfo";
import { Form, Formik } from "formik";
import useWindowDimensions from "hooks/useWindowDimensions";
import React, { useContext, useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Users from "services/apis/usersAPI";
import Wallets from "services/apis/walletsAPI";

import { isDev, logger } from "utils/logger/logger";
import * as Yup from "yup";
import {
  Container,
  HeaderLogin,
  LoginContainer,
  LoginFormcontainer,
  LogoContainer,
  RememberPass,
  SignUpInvitation,
} from "./index.styled";
import { convertToEnglishNumber } from "utils/validate";

export default function Login() {
  const dim = useWindowDimensions();
  const navigate = useNavigate();
  const userData = useContext(UserInfoContext);
  const captchaRef = useRef(null);
  const initialValues = {
    password: isDev() ? "!" : "@",
    mobile: "",
  };

  const validationSchema = Yup.object({
    mobile: Yup.string()
    .required("شماره تلفن الزامی می‌باشد")
    .matches(/[۰۱۲۳۴۵۶۷۸۹0-9]/, 'لطفا عدد وارد کنید')
    .max(11, 'تعداد ارقام وارد شده نباید بیشتر از ۱۱ باشد.')
    .min(11, 'تعداد ارقام وارد شده نباید کمتر از ۱۱ باشد.'),
    
    password: Yup.string().required("رمز عبور الزامی می‌باشد"),
  });
  const checkboxOptions = [
    { key: 1, value: "password", label: "ذخیره رمز عبور" },
  ];
  const [isCheckedRememberMe, setIsCheckedRememberMe] = useState(true);

  function checkRememberMe(event) {
    setIsCheckedRememberMe(event.target.checked);
  }
  const [captchaToken, setCaptchaToken] = useState("");

  const onLoad = () => {
    captchaRef.current.execute();
  };

  useEffect(() => {
    if (captchaToken) logger.log()(`hCaptcha Token: ${captchaToken}`);
  }, [captchaToken]);

  const handleSubmit = async (values) => {
    if ("rememberPass" in values && values?.rememberPass[0] === "password") {
      localStorage.setItem("rememberMe", true);
    } else {
      localStorage.setItem("rememberMe", false);
    }
    let captchaToken = captchaRef.current.getValue();
    captchaRef.current.reset();

    const reqObj = {
      mobile: convertToEnglishNumber(values.mobile),
      password: values.password,
      token: captchaToken,
    };

    const response = await new Users(reqObj).postLogin();

    if (response.type) {
      const { token, refreshToken, role } = response.data.data;

      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("role", role);

      const profileResponse = await new Users().getProfile();

      if (profileResponse.type) {
        userData.setUsersInfo(profileResponse.data?.data);
      }

      const walletResponse = await new Wallets().getWallet();

      if (walletResponse.type) {
        userData.setWalletData(walletResponse?.data.data.balance);
      }

      navigate("/convert-text-to-speech");
    } else {
      toast.error(response.message);
    }
  };

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <>
      <Helmet>
        <title>ورود</title>
      </Helmet>

      <LoginContainer>
        <LogoContainer color="#89BEFF">
          <div>
            <h2>آواشو</h2>
            <img src={avashologo} alt="logo" />
          </div>
        </LogoContainer>
        <Container>
          <LoginFormcontainer>
            <HeaderLogin color="#27548C">ورود به حساب کاربری</HeaderLogin>

            <Formik
              enableReinitialize
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
              placeholderColor="#2D3134"
              fontColor=""
            >
              {(formik) => {
                return (
                  <FormContainer>
                    <Form>
                      <FormikControl
                        control="input"
                        name="mobile"
                        placeholder="شماره موبایل"
                        width="388px"
                        label="شماره موبایل"
                        rightIcon={bluePhoneIcon}
                        placeholderColor="#27548C"
                        fontColor="#27548C"
                        borderColor="#E9EBF8"
                      />
                      <FormikControl
                        control="input"
                        name="password"
                        width="388px"
                        type="password"
                        label="رمز عبور"
                        placeholder="رمز عبور"
                        placeholderColor="#27548C"
                        rightIcon={blueLockIcon}
                        leftIcon
                        fontColor="#development27548C"
                        toggleType={true}
                        borderColor="#E9EBF8"
                      />
                      <div className="re-captcha">
                        <ReCAPTCHA
                          sitekey={env.REACT_APP_CAPTCHA_SITE_KEY}
                          ref={captchaRef}
                          size="normal"
                          theme="light"
                          type="image"
                          // onChange={onCaptchaChange}
                        />
                      </div>

                      <RememberPass>
                        {/* <FormikControl
                        control="checkbox"
                        name="rememberPass"
                        options={checkboxOptions}
                        display="horizontal"
                        // fontColor="#9EA0A2"
                      /> */}
                        <div>
                          <input
                            type="checkbox"
                            onChange={checkRememberMe}
                            defaultChecked={isCheckedRememberMe}
                          />
                          <span>ذخیره ی رمز عبور</span>
                        </div>
                        <Link to="/forgot-pass">فراموشی رمز عبور</Link>
                      </RememberPass>
                      <div className="button-wrapper">
                        <CustomButton
                          width="388px"
                          color="#F4F7FC"
                          height="56px"
                          height1024="48px"
                          radius="12px"
                          width417="340px"
                          width360="320px"
                          background="#6CAEFF"
                          borderColor="#6CAEFF"
                          backgroundHover="#FFFFFF"
                          colorHover="#6CAEFF"
                          type="submit"
                          borderColorHover="#6CAEFF"
                          disabled={!formik.isValid}
                        >
                          ورود
                        </CustomButton>
                      </div>

                      <SignUpInvitation>
                        <div>
                          <span>هنوز حسابی ایجاد نکرده اید؟</span>

                          {dim.width > 1024 ? (
                            <Link to="/enter-mobile"> ثبت نام </Link>
                          ) : (
                            <Link to="/enter-mobile">ایجاد حساب</Link>
                          )}
                          <span>کنید.</span>
                          <div
                            style={{
                              textAlign: "center",
                              opacity: 0.6,
                            }}
                          >
                            <span>نسخه :</span>
                            <span>{env.REACT_APP_VERSION}</span>
                          </div>
                        </div>
                      </SignUpInvitation>
                    </Form>
                  </FormContainer>
                );
              }}
            </Formik>
          </LoginFormcontainer>
          <Shape />
        </Container>
      </LoginContainer>
    </>
  );
}
